import React from "react";

// Layout components
import Dashboard from "layouts/dashboard";
import Sites from "layouts/sites";
import SiteDetail from "layouts/sites/detail";
import Deployments from "layouts/deployments";
import Domains from "layouts/domains";
import GitHubPage from "layouts/github";
import ActivityLogs from "layouts/activity";
import Settings from "layouts/settings";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Icons
import { IoHome, IoGlobe, IoRocketSharp, IoKey, IoLogoGithub, IoList, IoBuild, IoDocumentText } from "react-icons/io5";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <IoHome size="16px" color="inherit" />,
    component: Dashboard,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sites",
    key: "sites",
    route: "/sites",
    icon: <IoGlobe size="16px" color="inherit" />,
    component: Sites,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Deployments",
    key: "deployments",
    route: "/deployments",
    icon: <IoRocketSharp size="16px" color="inherit" />,
    component: Deployments,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Domains",
    key: "domains",
    route: "/domains",
    icon: <IoKey size="16px" color="inherit" />,
    component: Domains,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "GitHub",
    key: "github",
    route: "/github",
    icon: <IoLogoGithub size="16px" color="inherit" />,
    component: GitHubPage,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Logs / Activity",
    key: "activity",
    route: "/activity",
    icon: <IoList size="16px" color="inherit" />,
    component: ActivityLogs,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    route: "/settings",
    icon: <IoBuild size="16px" color="inherit" />,
    component: Settings,
    noCollapse: true,
  },

  // Hidden Route: GitHub OAuth Callback Route
  {
    type: "collapse",
    name: "GitHub Setup Callback",
    key: "github-setup-callback",
    route: "/setup/github",
    icon: <IoLogoGithub size="16px" color="inherit" />,
    component: GitHubPage,
    hidden: true,
    noCollapse: true,
  },

  // Hidden Route: Site Details
  {
    type: "collapse",
    name: "Site Details",
    key: "site-detail",
    route: "/sites/:id",
    icon: <IoGlobe size="16px" color="inherit" />,
    component: SiteDetail,
    hidden: true,
    noCollapse: true,
  },

  // Hidden Auth Routes
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <IoDocumentText size="16px" color="inherit" />,
    component: SignIn,
    hidden: true,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    icon: <IoRocketSharp size="16px" color="inherit" />,
    component: SignUp,
    hidden: true,
    noCollapse: true,
  },
];

export default routes;
